"use client";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "@/components/ui/Icon";
import { TransportVoucherData } from "@/types/navigation";
import { TransportVoucherPDF } from "./voucherPdf";

// Barre d'actions du bon de transport : téléchargement PDF, bascule édition,
// partage d'un lien en lecture seule. Le rendu est strictement identique à la
// version monolithique d'origine (mêmes classes, mêmes libellés).
type VoucherActionsBarProps = {
  data: TransportVoucherData;
  isReadOnly: boolean;
  effectiveIsEditing: boolean;
  onToggleEditing: () => void;
  onCopyReadOnlyLink: () => void;
  shareStatus: string | null;
};

export const VoucherActionsBar = ({
  data,
  isReadOnly,
  effectiveIsEditing,
  onToggleEditing,
  onCopyReadOnlyLink,
  shareStatus,
}: VoucherActionsBarProps) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
    <PDFDownloadLink
      document={<TransportVoucherPDF data={data} />}
      fileName={`bon-de-transport-${data.bonCommande || "vtc"}.pdf`}
      className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg bg-primary px-5 text-sm font-semibold uppercase tracking-wide text-black transition-all hover:bg-primary/90"
    >
      {({ loading }: { loading: boolean }) => (
        <>
          <Icon icon="material-symbols:download" className="h-5 w-5" />
          {loading ? "Préparation..." : "Télécharger le PDF"}
        </>
      )}
    </PDFDownloadLink>

    {!isReadOnly && (
      <button
        onClick={onToggleEditing}
        className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-black/15 bg-white px-5 text-sm font-semibold uppercase tracking-wide text-black transition-all hover:border-primary"
      >
        <Icon
          icon={
            effectiveIsEditing
              ? "material-symbols:close"
              : "material-symbols:edit"
          }
          className="h-5 w-5"
        />
        {effectiveIsEditing
          ? "Annuler les modifications"
          : "Modifier le document"}
      </button>
    )}
    <button
      onClick={onCopyReadOnlyLink}
      className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-black/15 bg-white px-5 text-sm font-semibold uppercase tracking-wide text-black transition-all hover:border-primary"
    >
      <Icon icon="material-symbols:link" className="h-5 w-5" />
      Partager à un autre VTC
    </button>
    {shareStatus && <p className="text-sm text-black/70">{shareStatus}</p>}
  </div>
);
